import React, { Fragment } from 'react';

export const textSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  speed: 8000,
  autoplaySpeed: 1000,
  cssEase: 'linear',
  arrows: false,
  variableWidth: true,
  adaptiveHeight: true,
};

export const navSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  speed: 8000,
  autoplaySpeed: 0,
  cssEase: 'linear',
  arrows: false,
  variableWidth: true,
  adaptiveHeight: true,
};

export const ACCESSORIES_LINK = '/sg/en/squid-game-sg-grip-5s-c1-accessories.html';
export const SEE_ALL_LINK = '/sg/en/eyeglasses/brands/squid-game.html';
export const STORES_LINK = '/stores/sg';

export const STORES_NOTES = [
  'Not valid with any discount, promotion and/or privilege',
  'No cancellation, refund, exchange or change of order details once an order is placed',
  'Resale or transfer is strictly prohibited',
  'Delivery within Singapore only',
  'Certain prescription cannot be added to the lenses due to constrains in the lens power',
  'Upgrade to optional lenses is available at additional charges',
  'Should there be any manufacturing defect, please contact our Customer Service Team at +65 6222 0588',
];

export const SHARES = [
  {
    link: 'https://www.facebook.com/sharer/sharer.php?u=https://www.owndays.com/sg/en/news/squid-game',
    className: 'fa-facebook',
  },
  {
    link: 'whatsapp://send?text=https://www.owndays.com/sg/en/news/squid-game',
    className: 'fa-whatsapp',
  },
];

export const MAIN_TEXT_RUN = ['오징어', '게임'];

export const NOVELTY = {
  NOTES: [
    'Design selected at random; no choice available',
    'Offer applies only to selected products and is valid while stocks last',
    'Resale or transfer of the gift item is strictly prohibited',
    'Management reserves the right to modify or terminate the campaign without prior notice',
  ],
};

export const LINEUP_NAV = ['YOUNG-HEE', 'STAIRCASE', 'FRONTMAN', 'TRACK SUIT', 'PIGGY BANK', 'OX'];

export const LINEUP = [
  {
    title: 'YOUNG-HEE',
    desc: `Inspired by the YOUNG-HEE doll, this oversized Boston-style frame captures the spirit of the game with its 3D bang effect and delicate hairpin details. Slip them on and be instantly transported to a thrilling world where style meets adventure.`,
    product: {
      number: 'SG1002X-5S',
      price: 'S$198',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: (
        <Fragment>
          Spectacle cloth adorned with a charming
          <br />
          YOUNG-HEE doll design
        </Fragment>
      ),
      colors: ['gold', 'matte-black'],
    },
    points: [
      'Bold rims echoing YOUNG-HEE’s iconic voluminous bangs',
      'Temple design inspired by YOUNG-HEE’s signature hairpin',
      'Embossed ○△□ symbols on the right temple tip—an homage to the iconic game shapes',
    ],
  },
  {
    title: 'STAIRCASE',
    desc: `A clear Boston frame inspired by the world of SQUID GAME Subtle nods to the iconic Dalgona candy shape and the protagonist’s number “456” are intricately featured on the frame. The temple tips showcase a vibrant, maze-like staircase design—leading you straight into the heart of the game.`,
    product: {
      number: 'SG2002N-5S',
      price: 'S$178',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: 'Spectacle cloth adorned with a vibrant yet haunting staircase design, evoking the maze that leads to the game venue',
      colors: ['clear', 'pink'],
    },
    points: [
      'Hybrid frame crafted from plastic and metal',
      'Temple tips in vibrant colors, inspired by staircase designs',
      '○△□ symbols delicately featured on the right temple tip',
    ],
  },
  {
    title: 'FRONTMAN',
    desc: `A polygonal Boston frame inspired by the pink guards and front men featuring a mesh pattern on the temples that echoes the masks worn by the pink guards, this frame invites you to step into the role of the elite—ready to command the game.`,
    product: {
      number: 'SG2001G-5S',
      price: 'S$198',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: 'Monochrome Frontman mask design on spectacle cloth',
      colors: ['matte-black', 'black'],
    },
    points: [
      'Polygonal front design inspired by the enigmatic personas of the Frontman and Pink Guy',
      'Temples adorned with a mesh pattern inspired by masquerade masks',
      '○△□ symbols from SQUID GAME on right temple tip',
    ],
  },
  {
    title: 'TRACK SUIT',
    desc: `A trendy rectangular frame inspired by Player and Pink Guard costumes Sporty rubber temples with striped accents add dynamic flair. The green C1 variant features the iconic “456” on the temple side—a subtle tribute to the main character’s number.`,
    product: {
      number: 'SG1001X-5S',
      price: 'S$178',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: 'Spectacle cloth adorned with a collection of iconic items from the game, symbolizing the players’ challenges',
      colors: ['green', 'matte-black'],
    },
    points: [
      'Rubber temples for a sleek, sporty finish',
      'Engraved banknote motifs on temples; temple tips shaped like pig noses',
      '○△□ symbols—iconic shapes from SQUID GAME—featured on the inner side of the right temple',
    ],
  },
  {
    title: 'PIGGY BANK',
    desc: `A hexagonal frame inspired by the theme of “money,” featuring banknote prints on the temples and metal accents shaped like a piggy bank’s nose. A design that teases your senses—making you want to take it home, even if it’s a tempting dilemma.`,
    product: {
      number: 'SG1003G-5S',
      price: 'S$178',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: 'A pig-shaped bank to safeguard your savings for a rainy day',
      colors: ['gold', 'silver'],
    },
    points: [
      'A frame inspired by the iconic piggy bank',
      'Banknote motifs on temples; temple tips shaped like pig noses',
      '○△□ symbols from SQUID GAME featured inside the right temple',
    ],
  },
  {
    title: 'OX',
    desc: `An eclectic blend of materials in a rectangular frame, adorned with metal dot-and-cross motifs on the front and temples. The dynamic color combination captures the urgency and rapid decision-making spirit of SQUID GAME.`,
    product: {
      number: 'SG2003G-5S',
      price: 'S$198',
      limit: 4,
      name: 'Cleaning Cloth Set',
      desc: 'Spectacle cloth printed with ○︎︎× motifs, evoking the imagery of voting ballots',
      colors: ['black-red', 'black-blue'],
    },
    points: [
      'Metal accents featuring ○︎︎×motifs embellish the frame front and temples',
      'Temple designs echo the iconic staircase motif',
      '○△□ symbols—the iconic SQUID GAME logo—subtly adorn the temple tips',
    ],
  },
];
